import service from "./service";

export const findAll = listQuery => {
  return service.get("/v1/color", listQuery);
};

export const update = (id, color) => {
  return service.post(`/v1/color/${id}/update`, { color });
};

export const create = color => {
  return service.post(`/v1/color`, { color });
};

export const remove = id => {
  return service.post(`/v1/color/${id}/delete`);
};

export const removeList = list => {
  return service.post(`/v1/color/deletes`, list);
};
